import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ApiUsersTab from './ApiUsersTab';
import TokensTab from './TokensTab';
import StatisticsCards from './StatisticsCards';

const TokenManagement = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-2">
          <h1 className="text-3xl font-bold text-gray-800">
            API Token Management
          </h1>
          <Link
            to="/dashboard"
            className="bg-gray-600 hover:bg-gray-700 text-white font-semibold px-4 py-2 rounded-lg shadow-md transition text-sm"
          >
            ← Back to Dashboard
          </Link>
        </div>
        <p className="text-gray-600">
          Manage programmatic API access for external applications and services
        </p>
      </div>

      {/* Help Section */}
      <div className="mb-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
        <h3 className="font-semibold text-blue-900 mb-2">How to use API Tokens</h3>
        <div className="text-sm text-blue-800 space-y-2">
          <p>1. <strong>Create an API User:</strong> First, create an API user to represent the application or service that will access the API.</p>
          <p>2. <strong>Generate a Token:</strong> Generate one or more tokens for the API user with specific permissions.</p>
          <p>3. <strong>Use the Token:</strong> Include the token in the Authorization header of your API requests:</p>
          <pre className="bg-blue-100 p-2 rounded mt-2 text-xs overflow-x-auto">
            Authorization: Bearer YOUR_TOKEN_HERE
          </pre>
          <p className="mt-2">4. <strong>Monitor Usage:</strong> Track token usage and rate limits in the Tokens tab.</p>
        </div>
      </div>

      {/* Statistics Cards */}
      <StatisticsCards />

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('users')}
            className={`${
              activeTab === 'users'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition duration-200`}
          >
            👥 API Users
          </button>
          <button
            onClick={() => setActiveTab('tokens')}
            className={`${
              activeTab === 'tokens'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition duration-200`}
          >
            🔑 API Tokens
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-lg">
        {activeTab === 'tokens' && <TokensTab />}
        {activeTab === 'users' && <ApiUsersTab />}
      </div>
    </div>
  );
};

export default TokenManagement;
